module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/custom-grid-02-c3f8954f44b3c4a94e51f1c5f61a32cc.jpg";